<div>
  <app-details-header
    [type]="'commApartment.nominative' | locCap"
    [header]="data.unit | longNumber"
    [icon]="'location_city'"
    (onEdit)="onEdit()"
    [useEdit]="canEdit"
  >
    <p>
      {{ 'user.lastOwnUpdate' | loc }}:
      <b>{{ data.unit.lastOwnerChange | lDate: 'dtShort' : ('label.never' | loc) }}</b>
    </p>
  </app-details-header>

  <div class="page-section">
    <app-details-section headerKey="commApartment.nominative" *ngIf="data.unit">
      <app-users-unit-basic-data
        [apartment]="data.unit"
        [shares]="data.displayShare"
        (showUnitCodes)="showUnitCodes = true"
      ></app-users-unit-basic-data>
    </app-details-section>

    <app-users-unit-meetings *ngIf="data.unit.unitCodes?.webcon" [unitId]="data.unit.id"></app-users-unit-meetings>

    <app-details-section headerKey="user.noteList">
      <app-notes [refId]="data.unit.id" [type]="NoteType.UNIT" [disableEdit]="!canEdit"></app-notes>
    </app-details-section>

    <app-all-integration-codes [codes]="data.unit.unitCodes" [(show)]="showUnitCodes"></app-all-integration-codes>

    <app-details-section
      [headerKey]="'parking.' + (data.parkings.length > 1 ? 'plural' : 'nominative')"
      *ngIf="data.parkings.length"
    >
      <app-users-rental-units-links [units]="data.parkings" [type]="RentalUnitType.PARKING"></app-users-rental-units-links>
    </app-details-section>

    <app-details-section
      [headerKey]="'storage.' + (data.storages.length > 1 ? 'plural' : 'nominative')"
      *ngIf="data.storages.length"
    >
      <app-users-rental-units-links [units]="data.storages" [type]="RentalUnitType.STORAGE"></app-users-rental-units-links>
    </app-details-section>

    <app-details-section headerKey="label.bankAccount">
      {{ bankAccount | iban: ('label.empty' | loc) }}
    </app-details-section>

    <app-details-section headerKey="unit.residents" *ngIf="data.unit">
      <app-users-residents-links [residents]="residents"> </app-users-residents-links>
    </app-details-section>

    <div class="padding-bottom-20">
      <mat-expansion-panel class="fliko-panel mat-elevation-z0" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ 'label.attachments' | locUpper }}</mat-panel-title>
        </mat-expansion-panel-header>
        <app-details-section *ngFor="let landlord of data.landlords; let last = last" [last]="last">
          <ng-container section-header>
            <span class="mat-caption">
              {{ 'label.for' | loc }}: <b> {{ landlord | fullName }} </b>
            </span>
          </ng-container>
          <app-users-details-files
            [unitId]="data.unit.id"
            [residentId]="landlord.id"
            [canEdit]="canEdit"
          ></app-users-details-files>
        </app-details-section>
      </mat-expansion-panel>
    </div>
  </div>
</div>
